import { render, staticRenderFns } from "./bannersDisplayBoards.vue?vue&type=template&id=62f019a4&"
import script from "./bannersDisplayBoards.vue?vue&type=script&lang=js&"
export * from "./bannersDisplayBoards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports